export const amazonTextractActions = [
  {
    name: 'amazonTextract',
    label: 'Amazon Textract',
    args: [
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'fieldForDocument',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'fieldForText',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
];
